import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Funciones } from '../../shared/funciones';
import { EmmitService } from '../../shared/componentes/emmit.service';
import { LoopBackAuth, UserApi } from '../../shared/sdk';

@Component({
  selector: 'frontend-page',
  templateUrl: './frontend.component.html'
})
export class FrontendComponent implements OnDestroy {

  private subscription: any;

  constructor(
    private emmitservice: EmmitService,
    public router: Router,
    public auth: LoopBackAuth,
    public funciones: Funciones,
    public userapi: UserApi,
  ) {

    this.subscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const data = this.auth.getToken();
        if (data) {
          const diff = this.funciones.getDateDiff(new Date(data.created));
          if (diff.days >= 1) {
            this.emmitservice.sendData({ type: 'front-header', msg: 'refresh-data' });
          }
        }

      }
    });

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/frontend.component.ts